import { CommentInput } from '@/components/comments/CommentInput';
import { Comment } from '@/components/comments/Comment';
import { Comment as CommentDto } from '@/actions/dtos/tender/comment';
import React, { useState } from 'react';
import { createComment, deleteComment, editComment } from '@/api/requests/comments';

interface CommentSectionProps {
  tenderId: string;
  comments: CommentDto[];
  refreshData: () => void;
}

export const CommentSection: React.FC<CommentSectionProps> = ({ tenderId, comments, refreshData }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleCreateComment = async (tenderId: string, message: string) => {
    try {
      setIsLoading(true);
      await createComment(tenderId, message);
      await refreshData();
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditComment = async (commentId: string, message: string) => {
    try {
      setIsLoading(true);
      const originalComment = comments.find((comment) => comment.id === commentId);
      if (originalComment?.message?.trim() !== message) {
        await editComment(commentId, message);
        refreshData();
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteComment = async (commentId: string) => {
    try {
      setIsLoading(true);
      await deleteComment(commentId);
      refreshData();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="relative flex flex-col">
      <div
        className="flex max-h-sm flex-col gap-5 overflow-y-auto p-1"
        style={{
          scrollbarWidth: 'none',
        }}
      >
        <CommentInput tenderId={tenderId} handleCreateComment={handleCreateComment} />
        {comments.map((comment) => (
          <Comment
            key={comment.id}
            comment={comment}
            handleDeleteComment={handleDeleteComment}
            handleEditComment={handleEditComment}
          />
        ))}
      </div>
      {isLoading && (
        <div className="absolute inset-0 z-10 flex items-center justify-center bg-base-100 bg-opacity-50">
          <span className="loading loading-spinner" />
        </div>
      )}
    </div>
  );
};
